import moment from "moment";

export const STATUS = {
  AGENDADA: "AGENDADA",
  ATIVA: "ATIVA",
  ENCERRADA: "ENCERRADA",
};

export const STATUS_CONFIG = {
  [STATUS.AGENDADA]: {
    label: "Agendada",
    color: "warning",
    badgeColor: "#f37b1d",
  },
  [STATUS.ATIVA]: {
    label: "Ativa",
    color: "success",
    badgeColor: "#5eb95e",
  },
  [STATUS.ENCERRADA]: {
    label: "Encerrada",
    color: "secondary",
    badgeColor: "#666",
  },
};

export function computeStatus(campanha) {
  const hoje = moment().startOf("day");
  const inicio = moment(campanha.dataInicio).startOf("day");
  const fim = moment(campanha.dataFim).startOf("day");

  if (inicio.isAfter(hoje)) {
    return STATUS.AGENDADA;
  }

  if (fim.isBefore(hoje)) {
    return STATUS.ENCERRADA;
  }

  return STATUS.ATIVA;
}

export function getStatusConfig(campanha) {
  const status = computeStatus(campanha);
  return { status, ...STATUS_CONFIG[status] };
}

export function isEncerrandoEmDias(campanha, dias = 7) {
  const hoje = moment().startOf("day");
  const fim = moment(campanha.dataFim).startOf("day");
  const status = computeStatus(campanha);

  return status === STATUS.ATIVA && fim.diff(hoje, "days") <= dias;
}
